// extracted by mini-css-extract-plugin
export default {"home":"Addvedio_home__QJyAp","hr":"Addvedio_hr__MaRtW","main":"Addvedio_main__mhJvd"};